import { render } from "./preloadShooperComponent1.vue?vue&type=template&id=4240325e"
import script from "./preloadShooperComponent1.vue?vue&type=script&lang=js"
export * from "./preloadShooperComponent1.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__